var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._g({ref:"input",staticClass:"summary--textarea",attrs:{"value":_vm.value || '',"error-messages":_vm.errorMessages,"dense":"","rows":"1","auto-grow":"","hide-details":""},on:{"input":(v) => _vm.$emit('input', v)}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }